import * as React from "react";
import { Typography, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import intl from "react-intl-universal";

import { CountryFlag } from "components/CountryFlag";
import { getDefaultLocale, setDefaultLocale } from "utils/localStorage";

const LOCALE = {
  EN_GB: "en-GB",
  ZH_CN: "zh-CN",
};

const useStyles = makeStyles((theme) => ({
  language: {
    display: "flex",
    alignItems: "center",
  },
  label: {
    marginRight: theme.spacing(2),
    color: "white",
  },
  flag: {
    width: "24px !important",
    height: "24px !important",
  },
  select: {
    "&.MuiInput-underline:before": {
      borderBottom: "1px solid rgb(250, 250, 250)",
    },
    "& div": {
      padding: 0,
    },
  },
}));

export const LanguageSelector = () => {
  const classes = useStyles();
  return (
    <div className={classes.language}>
      <Typography className={classes.label}>
        {intl.get("LANGUAGE_SELECTOR_LABEL")}
      </Typography>
      <Select
        className={classes.select}
        color="secondary"
        value={getDefaultLocale()}
        onChange={(event) => {
          setDefaultLocale(event.target.value as string);
          window.location.reload();
        }}
      >
        <MenuItem value={LOCALE.EN_GB}>
          <CountryFlag size={1.4} countryCode="gb" />
        </MenuItem>
        <MenuItem value={LOCALE.ZH_CN}>
          <CountryFlag size={1.4} countryCode="cn" />
        </MenuItem>
      </Select>
    </div>
  );
};
